import { render, staticRenderFns } from "./document-editor.vue?vue&type=template&id=05183cd9"
import script from "./document-editor.vue?vue&type=script&lang=js"
export * from "./document-editor.vue?vue&type=script&lang=js"
import style0 from "./document-editor.vue?vue&type=style&index=0&id=05183cd9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports